import {Component, OnInit, signal} from '@angular/core';
import {DecorationsService} from '../../services/decorations/decorations.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Decoration} from '../../classes/decoration.class';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatError, MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatCheckbox} from "@angular/material/checkbox";
import {NgSelectComponent} from "@ng-select/ng-select";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-decoration-detail',
    templateUrl: './decoration-detail.component.html',
    styleUrls: ['./decoration-detail.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        ReactiveFormsModule,
        MatFormField,
        MatError,
        MatLabel,
        MatInput,
        MatCheckbox,
        NgSelectComponent,
        MatButton
    ]
})
export class DecorationDetailComponent implements OnInit {

    readonly decoration = signal<Decoration>(null);
    readonly groups = signal<string[]>([]);
    types = ['Figuratie', 'Lengtemarkering', 'Luchthaven'];

    public readonly form = signal<FormGroup>(new FormGroup({
        name: new FormControl('', [Validators.min(0), Validators.max(99)]),
        surface: new FormControl('', [Validators.min(0.001), Validators.max(999999.999)]),
        type: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
        decoration_group: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
        specify_length: new FormControl('', []),
        priority_figuration: new FormControl('', []),
        specific_price: new FormControl(false),
        mold: new FormControl(false)
    }));

    constructor(
        private decorationsService: DecorationsService,
        private router: Router,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {

            this.decorationsService.getList().then(decorations => {
                const newGroups = [];
                let foundDecoration = null;

                decorations.forEach(decoration => {
                    if (decoration.id === +params['id']) {
                        foundDecoration = decoration;
                    }
                    if (newGroups.indexOf(decoration.decoration_group) === -1) {
                        newGroups.push(decoration.decoration_group);
                    }
                });

                this.groups.set(newGroups);
                this.decoration.set(foundDecoration || new Decoration());

                Object.entries(this.form().controls).forEach(control => {
                    if (typeof this.decoration()[control[0]] !== 'undefined') {
                        this.form().controls[control[0]].setValue(this.decoration()[control[0]]);
                    }
                });
            });
        });
    }

    save() {
        if (this.form().valid) {
            Object.assign(this.decoration(), this.form().value);
            this.decorationsService.save(this.decoration()).then(decoration => {
                this.router.navigate([`decorations`]);
            }, error => {

            });
        } else {
            for (const name of Object.keys(this.form().controls)) {
                this.form().controls[name].markAsTouched();
            }
        }

    }

}
